import { Cell } from '@table-library/react-table-library/table';

export const COLUMNS = (t) => [
    {
        label: t('user_activities.columns.user'),
        key: 'user',
        data: 'user',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <a
                    href={`/admin/customers/useractivity/?q=${encodeURIComponent(data)}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    {data}
                </a>
            );
        },
    },
    {
        label: t('user_activities.columns.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
    },
    {
        label: t('user_activities.columns.lastAccess'),
        key: 'created',
        data: 'created',
        Component: Cell,
    },
    {
        label: t('user_activities.columns.pages'),
        key: 'pages_count',
        data: 'pages_count',
        Component: Cell,
    },
    {
        label: t('user_activities.columns.uniquePagesCount'),
        key: 'unique_pages_count',
        data: 'unique_pages_count',
        Component: Cell,
    },
    {
        label: t('user_activities.columns.datesCount'),
        key: 'days_count',
        data: 'days_count',
        Component: Cell,
    },
];
